import { addError } from "../store/reducer/_uiReducer";
import { ErrorMessage } from "./classes";

export type NotifyPayload = {
  message: string;
  title: string;
  variant: "success" | "warning" | "danger" | "light";
};

export const notify = (
  dispatch: any,
  payload: NotifyPayload,
) => {
  dispatch(addError(new ErrorMessage(payload as any)));
};
